import classNames from 'classnames';
import React from 'react';
import styles from './button.module.css.js';

const Button = ({ children, className, onClick, 'data-testid': dataTestId, variant = '', disabled, type = 'button', size = '', form, outline = false, title, }) => (React.createElement("button", { type: type, onClick: onClick, className: classNames(styles.button, className, {
        [styles[variant]]: variant,
        [styles[size]]: size,
        [styles.outline]: outline,
    }), "data-testid": dataTestId, disabled: disabled, form: form, title: title }, children));

export { Button };
